import { gql } from '@apollo/client';

/**
 * Constraint GraphQL Fragment - All fields with Rust struct parity
 */
export const CONSTRAINT_FIELDS_FRAGMENT = gql`
  fragment ConstraintFields on Constraint {
    # Identity (6)
    id
    name
    code
    description
    constraintType
    domainContext

    # Append-Only Architecture (4)
    parentId
    originalId
    recordVersion
    isActive

    # Formula Interaction (6)
    monitoredEntityId
    monitoredEntityType
    notificationActorIds
    notificationChannels
    notificationAtPercent
    overrideApprovalWorkflowId

    # User Customization (5)
    isSystemConstraint
    createdByUser
    userCustomizable
    templateId
    customFormula

    # Constraint Definition (7)
    constrainedEntity
    entitySubtype
    operator
    limitValue
    secondaryLimit
    unit
    timeWindow

    # Scope & Enforcement (5)
    scope {
      scopeType
      scopeId
    }
    enforcementPhase
    violationAction
    overrideAllowedBy
    overrideRequiresReason

    # Advanced Configuration (1)
    parameters

    # Tracking (5)
    currentUsage
    peakUsage
    lastResetAt
    totalViolationCount
    periodViolationCount

    # Runtime State (2)
    currentStatus
    usagePercent

    # Violation Logging (3)
    lastViolation {
      violationId
      violatedAt
      violatedBy
      attemptedValue
      limitValueAtViolation
      overagePercent
      actionTaken
      wasOverridden
      overrideApprovedBy
      overrideReason
      violationContext
      resolutionStatus
      resolutionNotes
    }
    violationHistory {
      violationId
      violatedAt
      violatedBy
      attemptedValue
      limitValueAtViolation
      overagePercent
      actionTaken
      wasOverridden
      overrideApprovedBy
      overrideReason
      violationContext
      resolutionStatus
      resolutionNotes
    }
    autoDisableThreshold

    # Lifecycle (2)
    active
    effectiveDates {
      startDate
      endDate
    }

    # Audit Trail (5)
    createdAt
    updatedAt
    createdBy
    updatedBy
    auditVersion

    # Metadata (1)
    metadata
  }
`;
